(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ra-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ra-shoppable-videos')) {
    customElements.define('ra-shoppable-videos', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected || this.events) return;
        this.track = this.querySelector('[data-video-track]');
        if (!this.track) return;
        this.events = new AbortController();
        if (this.dataset.feedUrl) {
          this.querySelector('[data-feed-retry]').addEventListener('click', () => this.loadDynamicCards(), { signal: this.events.signal });
          this.loadDynamicCards();
        } else this.setupCarousel();
      }
      async loadDynamicCards() {
        if (this.feedLoading) return;
        this.feedLoading = true;
        const signal = this.events.signal;
        const status = this.querySelector('[data-feed-status]');
        const message = this.querySelector('[data-feed-message]');
        const retry = this.querySelector('[data-feed-retry]');
        message.textContent = message.dataset.loading;
        retry.hidden = true;
        this.track.setAttribute('aria-busy', 'true');
        const cards = [];
        const productIds = new Set();
        const visited = new Set();
        const limit = Math.min(16, Math.max(2, Number(this.dataset.feedLimit) || 6));
        let url = new URL(this.dataset.feedUrl, location.origin);
        let requestFailed = false;
        try {
          while (url && cards.length < limit) {
            url.searchParams.set('sort_by', 'created-descending');
            url.searchParams.set('section_id', 'ra-shoppable-video-feed');
            if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid video feed pagination');
            visited.add(url.href);
            const request = new AbortController();
            const abort = () => request.abort();
            signal.addEventListener('abort', abort, { once: true });
            const timeout = setTimeout(abort, 15000);
            let html;
            try {
              const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin' });
              if (!response.ok) throw new Error('Video feed unavailable');
              html = await response.text();
            } finally {
              clearTimeout(timeout);
              signal.removeEventListener('abort', abort);
            }
            if (signal.aborted || !this.isConnected) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const feed = doc.querySelector('[data-ra-video-feed]');
            const results = feed?.querySelector('template[data-video-results]');
            if (!feed || !results) throw new Error('Invalid video feed');
            for (const card of results.content.querySelectorAll('[data-video-card]')) {
              if (productIds.has(card.dataset.videoProductId)) continue;
              productIds.add(card.dataset.videoProductId);
              cards.push(card);
              if (cards.length === limit) break;
            }
            url = feed.dataset.next ? new URL(feed.dataset.next, url) : null;
          }
        } catch (error) {
          if (signal.aborted) return;
          requestFailed = true;
        } finally {
          if (!signal.aborted) this.feedLoading = false;
        }
        if (signal.aborted || !this.isConnected) return;
        this.track.setAttribute('aria-busy', 'false');
        if (cards.length) {
          this.track.replaceChildren(...cards);
          status.hidden = true;
          this.querySelector('.ra-video-shop__navigation').hidden = false;
          this.setupCarousel();
        } else {
          message.textContent = requestFailed ? message.dataset.error : message.dataset.empty;
          retry.hidden = !requestFailed;
        }
      }
      setupCarousel() {
        if (this.carouselReady) return;
        this.carouselReady = true;
        const options = { signal: this.events.signal };
        this.media = Array.from(this.querySelectorAll('[data-video-media]'));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.previous = this.querySelector('[data-video-prev]');
        this.next = this.querySelector('[data-video-next]');
        this.previous.hidden = this.next.hidden = false;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.media.forEach(frame => {
          const button = frame.querySelector('[data-video-toggle]');
          button.hidden = false;
          button.addEventListener('click', () => {
            const video = this.loadVideo(frame);
            if (video.paused) {
              frame.dataset.userPaused = 'false';
              frame.dataset.userStarted = 'true';
              if (video.error) video.load();
              this.playVideo(frame);
            } else {
              frame.dataset.userPaused = 'true';
              video.pause();
            }
          }, options);
        });
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            entry.target.dataset.visible = String(entry.isIntersecting && entry.intersectionRatio >= .5);
            this.syncVideo(entry.target);
          });
        }, { threshold: [0, .5, 1] });
        this.media.forEach(frame => this.observer.observe(frame));
        document.addEventListener('visibilitychange', () => this.media.forEach(frame => this.syncVideo(frame)), options);
        this.motion.addEventListener('change', () => this.media.forEach(frame => this.syncVideo(frame)), options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.ra-video-shop__card');
          if (card) card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
        }, options);
        this.resize = new ResizeObserver(() => this.updateNavigation());
        this.resize.observe(this.track);
        this.updateNavigation();
      }
      loadVideo(frame) {
        let video = frame.querySelector('video');
        if (video) return video;
        frame.append(frame.querySelector('template').content.cloneNode(true));
        video = frame.querySelector('video');
        video.muted = true;
        video.defaultMuted = true;
        const button = frame.querySelector('[data-video-toggle]');
        const update = () => {
          button.toggleAttribute('data-playing', !video.paused);
          button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        };
        const options = { signal: this.events.signal };
        video.addEventListener('playing', () => { frame.setAttribute('data-ready', ''); update(); }, options);
        video.addEventListener('pause', update, options);
        video.addEventListener('error', () => { frame.removeAttribute('data-ready'); update(); }, options);
        return video;
      }
      playVideo(frame) {
        const video = this.loadVideo(frame);
        const play = video.play();
        if (play) play.catch(() => {
          const button = frame.querySelector('[data-video-toggle]');
          button.removeAttribute('data-playing');
          button.setAttribute('aria-label', button.dataset.playLabel);
        });
      }
      syncVideo(frame) {
        const canPlay = !document.hidden && frame.dataset.visible === 'true' && frame.dataset.userPaused !== 'true';
        const wantsPlay = frame.dataset.userStarted === 'true' || (this.dataset.autoplay === 'true' && !this.motion.matches);
        if (canPlay && wantsPlay) this.playVideo(frame);
        else frame.querySelector('video')?.pause();
      }
      move(direction) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * rtl * (card.getBoundingClientRect().width + gap), behavior: this.motion.matches ? 'auto' : 'smooth' });
      }
      updateNavigation() {
        const position = Math.abs(this.track.scrollLeft);
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= this.track.scrollWidth - this.track.clientWidth - 2;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
        this.media?.forEach(frame => frame.querySelector('video')?.pause());
        this.events = null;
        this.carouselReady = false;
        this.feedLoading = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-tiktok-live"]) return;
  try {
    
  if (!customElements.get('ra-tiktok-live')) {
    class RaTikTokLive extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.link = this.querySelector('.ra-tiktok-live__link');
        this.editor = this.dataset.editorPreview === 'true';
        this.storageKey = 'ra-tiktok-live:' + this.dataset.themeId;
        this.state = this.readState();
        this.updateSchedule = this.refresh.bind(this);
        this.clock = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Rome',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23'
        });
        window.addEventListener('focus', this.updateSchedule, options);
        window.addEventListener('pageshow', this.updateSchedule, options);
        document.addEventListener('visibilitychange', this.updateSchedule, options);
        window.addEventListener('resize', () => this.restorePosition(), options);
        this.link.addEventListener('pointerdown', event => this.startDrag(event), options);
        this.link.addEventListener('pointermove', event => this.moveDrag(event), options);
        this.link.addEventListener('pointerup', event => this.endDrag(event), options);
        this.link.addEventListener('pointercancel', event => this.endDrag(event), options);
        this.link.addEventListener('lostpointercapture', event => this.endDrag(event), options);
        this.link.addEventListener('dragstart', event => event.preventDefault(), options);
        this.link.addEventListener('click', event => {
          if (performance.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { ...options, capture: true });
        this.link.addEventListener('keydown', event => this.moveWithKeyboard(event), options);
        this.querySelector('.ra-tiktok-live__close').addEventListener('click', () => {
          this.state.dismissedDate = this.dayKey;
          this.saveState();
          this.hidden = true;
        }, options);
        this.refresh();
      }

      readState() {
        if (this.editor) return {};
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || '{}');
          if (!saved || typeof saved !== 'object' || Array.isArray(saved)) return {};
          return saved;
        } catch {
          return {};
        }
      }

      saveState() {
        if (this.editor) return;
        try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.state)); } catch {}
      }

      refresh() {
        window.clearTimeout(this.timer);
        const now = new Date();
        const parts = Object.fromEntries(this.clock.formatToParts(now).map(part => [part.type, part.value]));
        const weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(parts.weekday);
        const minutes = Number(parts.hour) * 60 + Number(parts.minute);
        const scheduled = weekday && minutes >= 740 && minutes < 900;
        this.dayKey = parts.year + '-' + parts.month + '-' + parts.day;
        const wasHidden = this.hidden;
        this.hidden = !(scheduled || this.editor) || this.state.dismissedDate === this.dayKey;
        if (wasHidden && !this.hidden) this.restorePosition();
        this.timer = window.setTimeout(this.updateSchedule, 60000 - (now.getTime() % 60000));
      }

      limits() {
        const rect = this.getBoundingClientRect();
        return {
          minX: 16,
          minY: 20,
          maxX: Math.max(16, document.documentElement.clientWidth - rect.width - 16),
          maxY: Math.max(20, window.innerHeight - rect.height - 16)
        };
      }

      setPosition(x, y) {
        const bounds = this.limits();
        this.style.left = Math.min(bounds.maxX, Math.max(bounds.minX, x)) + 'px';
        this.style.top = Math.min(bounds.maxY, Math.max(bounds.minY, y)) + 'px';
        this.style.right = 'auto';
        this.style.transform = 'none';
      }

      rememberPosition() {
        const bounds = this.limits();
        const rect = this.getBoundingClientRect();
        this.state.position = {
          x: (rect.left - bounds.minX) / Math.max(1, bounds.maxX - bounds.minX),
          y: (rect.top - bounds.minY) / Math.max(1, bounds.maxY - bounds.minY)
        };
        this.saveState();
      }

      restorePosition() {
        const pos = this.state.position;
        if (this.hidden || this.drag || !pos || !Number.isFinite(pos.x) || !Number.isFinite(pos.y)) return;
        const bounds = this.limits();
        this.setPosition(bounds.minX + pos.x * (bounds.maxX - bounds.minX), bounds.minY + pos.y * (bounds.maxY - bounds.minY));
      }

      startDrag(event) {
        if (!event.isPrimary || event.button !== 0) return;
        const rect = this.getBoundingClientRect();
        this.suppressClickUntil = 0;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rect.left, top: rect.top, moved: false };
        this.link.setPointerCapture(event.pointerId);
      }

      moveDrag(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const dx = event.clientX - this.drag.x;
        const dy = event.clientY - this.drag.y;
        if (!this.drag.moved && Math.hypot(dx, dy) < 6) return;
        this.drag.moved = true;
        this.classList.add('ra-tiktok-live--dragging');
        event.preventDefault();
        this.pendingPosition = { x: this.drag.left + dx, y: this.drag.top + dy };
        if (!this.frame) {
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (this.pendingPosition) this.setPosition(this.pendingPosition.x, this.pendingPosition.y);
          });
        }
      }

      endDrag(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const drag = this.drag;
        this.drag = null;
        cancelAnimationFrame(this.frame);
        this.frame = null;
        if (drag.moved) {
          if (this.pendingPosition) this.setPosition(this.pendingPosition.x, this.pendingPosition.y);
          this.suppressClickUntil = performance.now() + 800;
          this.rememberPosition();
        }
        this.pendingPosition = null;
        this.classList.remove('ra-tiktok-live--dragging');
        if (this.link.hasPointerCapture(event.pointerId)) this.link.releasePointerCapture(event.pointerId);
      }

      moveWithKeyboard(event) {
        const step = event.shiftKey ? 32 : 16;
        const directions = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] };
        const delta = directions[event.key];
        if (!delta) return;
        event.preventDefault();
        const rect = this.getBoundingClientRect();
        this.setPosition(rect.left + delta[0], rect.top + delta[1]);
        this.rememberPosition();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.controller?.abort();
        this.drag = null;
        this.pendingPosition = null;
        this.classList.remove('ra-tiktok-live--dragging');
      }
    }
    customElements.define('ra-tiktok-live', RaTikTokLive);
  }

  } catch(e) { console.error(e); }
})();
})();
